export class ChangeCartButton {
    /**
     *  商品のカートボタンの切り替え
     *
     *  @constructor
     *  @param {Element} root - ルートとなる要素
     */
    constructor(root) {
        if (!root) {
            return;
        }

        this.root = root;

        /**
         *  商品を選択するselect要素
         *
         *  @type {HTMLSelectElement | null}
         */
        this.select = this.root.querySelector('.js-change-cart-button__select');

        /**
         *  カートボタン群
         *
         *  @type {NodeListOf<HTMLElement> | null}
         */
        this.buttons = this.root.querySelectorAll('.js-change-cart-button__button');

        this.setSelectChangeEvent();
    }

    /**
     * select要素の選択肢を変更した際のイベント
     *
     * @return {Void}
     */
    setSelectChangeEvent() {
        if (!this.select) {
            return;
        }

        this.select.addEventListener('change', () => {
            const selectItem = this.select.options[this.select.selectedIndex];
            const {modalId} = selectItem.dataset;

            // 選択したアイテムが完売している場合
            if (selectItem.dataset.soldout === 'true' && this.buttons) {
                for (const button of this.buttons) {
                    if (button.dataset.buttonType === 'sold') {
                        button.innerText = '完売しました';
                        button.hidden = false;
                    } else {
                        button.hidden = true;
                    }
                }

            // 選択したアイテムが販売終了の場合
            } else if (selectItem.dataset.close === 'after' && this.buttons) {
                for (const button of this.buttons) {
                    if (button.dataset.buttonType === 'sold') {
                        button.innerText = '販売終了';
                        button.hidden = false;
                    } else {
                        button.hidden = true;
                    }
                }

            // 選択したアイテムが販売開始前の場合
            } else if (selectItem.dataset.close === 'before' && this.buttons) {
                for (const button of this.buttons) {
                    if (button.dataset.buttonType === 'sold') {
                        button.innerText = '販売開始前';
                        button.hidden = false;
                    } else {
                        button.hidden = true;
                    }
                }

            // 選択したアイテムからさらにモーダルダイアログでの選択がある場合
            } else if (modalId && this.buttons) {
                for (const button of this.buttons) {
                    if (button.dataset.buttonType === 'modal' && modalId === button.getAttribute('href').slice(1)) {
                        button.hidden = false;
                    } else {
                        button.hidden = true;
                    }
                }

            // 選択したアイテムが直接カートに追加される場合
            } else if (this.buttons) {
                for (const button of this.buttons) {
                    if (button.dataset.buttonType === 'add-cart') {
                        button.hidden = false;
                    } else {
                        button.hidden = true;
                    }
                }
            }
        });
    }
}

export default () => {
    const roots = document.querySelectorAll('.js-change-cart-button');

    if (!roots) {
        return;
    }

    roots.forEach((element) => new ChangeCartButton(element));
};
